import { render, staticRenderFns } from "./OrganizationEditDetails.vue?vue&type=template&id=59e0fc4e&scoped=true&"
import script from "./OrganizationEditDetails.vue?vue&type=script&lang=js&"
export * from "./OrganizationEditDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationEditDetails.vue?vue&type=style&index=0&id=59e0fc4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e0fc4e",
  null
  
)

export default component.exports